const productData = {
    // =====brand====
    brand: () => 'admin/brand',
    brandById: (id: string) => `admin/brand/${id}`,
    brandSearch: () => 'store/brand/search',


    // =====Product Type====
    productType: () => 'admin/product-type',
    productTypeById: (id: string) => `admin/product-type/${id}`,

    // ================ For Filter =========================
    // =====brand====
    commonBrand: () => 'admin/common/brand',
    // =====Product Type====
    commonProductType: () => 'admin/common/product-type',
    // =====Product Material====
    commonProductMaterial: () => 'admin/common/product-material',
    // =====Product Shape====
    commonProductShape: () => 'admin/common/product-shape',
    // =====Product Color====
    commonProductColor: () => 'admin/common/color-code',
    // =========================  end =========================

    // =====Product Material====
    productMaterial: () => 'admin/product-material',
    productMaterialById: (id: string) => `admin/product-material/${id}`,

    // =====Product Shape====
    productShape: () => 'admin/product-shape',
    productShapeById: (id: string) => `admin/product-shape/${id}`,

    // =====Product Color====
    productColor: () => 'admin/color-code',
    productColorById: (id: string) => `admin/color-code/${id}`,


    sizeDetails: () => 'admin/size-details',
}
export default productData